import Script from 'next/script';
import { Page } from '@thisisdevelopment/heritage-core-library';
import styled from 'styled-components';
import theme from 'theme';

const IFrame = styled.iframe`
  @media ${theme.mediaQuery.mobile} {
    min-height: 700px;
  }
  min-height: 550px;
`;

export default function Newsletter() {
  return (
    <Page
      title="Join our newsletter"
      headline="If you want to hear more about our products, the latest news, trends and ideas, sign up today!"
    >
      <Script
        id="munchkin"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
               (function() {
    var didInit = false;
    function initMunchkin() {
      if(didInit === false) {
        didInit = true;
        Munchkin.init('126-DNG-032', {"wsInfo":"j0hRdtjOKwEN"});
      }
    }
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = '//munchkin.marketo.net/munchkin.js';
    s.onreadystatechange = function() {
      if (this.readyState == 'complete' || this.readyState == 'loaded') {
        initMunchkin();
      }
    };
    s.onload = initMunchkin;
    document.getElementsByTagName('head')[0].appendChild(s);
    })();
        `,
        }}
      ></Script>
      <IFrame
        src="https://lp.akz.no/UKI-Dulux-Heritage-Newsletter-Registration.html"
        width="100%"
        height="100%"
        loading="lazy"
        style={{ border: 0, paddingTop: '40px' }}
        allowFullScreen
        aria-hidden="false"
        tabIndex={0}
      ></IFrame>
    </Page>
  );
}
